export default {
  SIZE_RECOMMENDATION: {
    TITLE: 'Size Recommendation',
    SUBTITLE:
      'Kami memberikan ukuran rekomendasi berdasarkan usia pada anak, ketebalan dan ukuran setiap size berbeda, berikut rekomendasi dari kami untuk pillow & bolster ( bantal & guling )',
    SMALL: {
      TITLE: '(S) Small / Kecil',
      AGE: 'Newborn - 1 Tahun',
      BOLSTER: 'Bolster: 13cm x 30cm',
      PILLOW: 'Pillow: 34cm x 22cm'
    },
    MEDIUM: {
      TITLE: '(M) Medium / Sedang',
      AGE: '1 Tahun - 2 Tahun',
      BOLSTER: 'Bolster: 18cm x 40cm',
      PILLOW: 'Pillow: 38cm x 25cm'
    },
    LARGE: {
      TITLE: '(L) Large / Besar',
      AGE: '2 Tahun - 5 Tahun',
      BOLSTER: 'Bolster: 23cm x 55cm',
      PILLOW: 'Pillow: 50cm x 30cm'
    },
    XL: {
      TITLE: '(XL) Jumbo / Raksasa',
      AGE: '5 Tahun - Dewasa',
      BOLSTER: 'Bolster: 31cm x 84cm',
      PILLOW: 'Pillow: 65cm x 42cm'
    }
  }
}
